// extracted by mini-css-extract-plugin
module.exports = {"tandc-title":"legal-notices_tandc-title__rX59H"};